import { Box } from "@mui/material";
import { useContext, useEffect, useMemo } from "react";
import { LayoutContext } from "wcz-layout";
import { useTime } from "react-timer-hook";

// ponytail: filenames hardcoded — CRA can't list public/ at runtime; update when images change
const images = ["apple", "banana", "beet", "bell-pepper", "blueberry", "carrot", "cauliflower", "celery", "cucumber", "dandelion", "lettuce", "parsley", "pear", "raspberry", "spinach", "strawberry", "watermelon"];

export default function TvPage(): JSX.Element {
    const { changeTitle } = useContext(LayoutContext);
    const { minutes, hours } = useTime();

    useEffect(() => changeTitle("Rate canteen"), []);

    const day = new Date().getDate();
    // random image per refresh, re-rolled when the day changes
    const image = useMemo(() => images[Math.floor(Math.random() * images.length)], [day]);

    const formatTime = (time: number) => time.toString().padStart(2, "0");

    return (
        <Box sx={{ height: "calc(100vh - 64px)", position: "relative", overflow: "hidden", bgcolor: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box component="img" src={`/tv-bg/${image}.jpg`} alt="" sx={{ position: "absolute", right: "2%", bottom: "3%", height: "34vh", maxWidth: "45vw", objectFit: "contain", filter: "brightness(1.04)" }} />
            {/* ponytail: SVG (not CSS min()/vw font) so it fills an exact width on the TV's old browser
                regardless of which font it falls back to. Knobs: width = side margin, mb = lift above bunnies. */}
            <Box
                component="svg"
                viewBox="0 0 900 300"
                preserveAspectRatio="xMidYMid meet"
                sx={{
                    zIndex: 1,
                    width: "97vw",
                    height: "34vw",
                    mb: "14vh",
                    "@keyframes blink": {
                        "0%, 49%": { opacity: 1 },
                        "50%, 100%": { opacity: 0.12 }
                    }
                }}
            >
                <text
                    x="450"
                    y="255"
                    textAnchor="middle"
                    textLength="900"
                    lengthAdjust="spacingAndGlyphs"
                    fontFamily="'Arial Black','Helvetica',sans-serif"
                    fontWeight={900}
                    fontSize="300"
                    fill="#1c1c1c"
                >
                    {formatTime(hours)}
                    <Box component="tspan" fill="#d32f2f" sx={{ animation: "blink 1s linear infinite" }}>:</Box>
                    {formatTime(minutes)}
                </text>
            </Box>
        </Box>
    );
}
